import React from 'react';
import PropTypes from 'prop-types';
import FourNumberFields from './FourNumberFields';

const MedianEFEstimates = (props) => {
  return (<FourNumberFields
    labels={{
      first: 'Median',
      second: 'Median Range Factor',
      third: 'Error Factor',
      fourth: 'Error Factor Range',
    }}
    {...props}
  />);
};

MedianEFEstimates.propTypes = {
  index: PropTypes.number.isRequired,
  selected: PropTypes.arrayOf(Number).isRequired,
  onUpdate: PropTypes.instanceOf(Function).isRequired,
  onRemove: PropTypes.instanceOf(Function).isRequired,
};

export default MedianEFEstimates;
